<!-- 内容审核与上下线 -->
<template>
  <div>
    <bread-crumb></bread-crumb>

    <div class="search-bar">
      <div class="input-group">
        <el-input
          style="width: 32%"
          v-model="searchParams.penalizedPin"
          placeholder="被举报人pin"
          clearable
        />
        <el-select
          style="width: 32%"
          v-model="searchParams.durationDays"
          placeholder="处罚时间"
          clearable
        >
          <el-option
            v-for="(item, index) in JinOptions"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          />
        </el-select>

        <el-input
          style="width: 32%"
          v-model="searchParams.createBy"
          placeholder="操作人erp"
          clearable
        ></el-input>
        <el-date-picker
          style="width: 32%"
          v-model="datePickerValue"
          type="datetimerange"
          range-separator="至"
          start-placeholder="受罚开始日期"
          end-placeholder="受罚结束日期"
          format="yyyy-MM-dd HH:mm:ss"
        />
        <div class="button-group">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>

    <div class="content-audit-tabel specil">
      <div class="base-table">
        <div class="base-table-table">
          <el-table
            ref="table"
            :data="tableData.tableList"
            style="width: 100%"
            stripe
            :cell-class-name="addClass"
            @selection-change="handleSelectionChange"
          >
            <template v-for="(item, index) in tableData.tableHeader">
              <el-table-column
                :prop="item.prop"
                :label="item.label"
                :align="left"
                :key="index"
                :width="item.width ? item.width : null"
              >
                <template slot-scope="scope">
                  <div v-if="item.label == '被举报人pin'">
                    <p>{{ scope.row[item.prop] }}</p>
                  </div>
                  <div v-if="item.label == '处罚时间'">
                    <p>{{ scope.row[item.prop] }}天</p>
                  </div>
                  <div v-if="item.label == '受罚开始时间'">
                    <p>{{ scope.row[item.prop] | timeTransform }}</p>
                  </div>
                  <div v-if="item.label == '受罚结束时间'">
                    <p>{{ scope.row[item.prop] | timeTransform }}</p>
                  </div>
                  <div v-if="item.label == '处理时间'">
                    <p>{{ scope.row[item.prop] | timeTransform }}</p>
                  </div>
                  <div v-if="item.label == '操作人erp'">
                    <p>{{ scope.row[item.prop] }}</p>
                  </div>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    />
  </div>
</template>

<script>
import breadCrumb from "../../../../components/breadCrumb";
import pagination from "../../../../components/pagination";
import { queryUserPenalties } from "../../../../api/complaint";
import utils from "../../../../utils";

export default {
  name: "goTopManage",
  data() {
    return {
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "被举报人pin",
            prop: "penalizedPin",
            width: "250px",
          },
          {
            label: "处罚时间",
            prop: "durationDays",
          },
          {
            label: "受罚开始时间",
            prop: "startTime",
          },
          {
            label: "受罚结束时间",
            prop: "endTime",
          },
          {
            label: "处理时间",
            prop: "updateTime",
          },
          {
            label: "操作人erp",
            prop: "createBy",
            width: "150px",
          },
        ],
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      searchParams: {
        penalizedPin: "",
        durationDays: "",
        createBy: "",
      },
      JinOptions: [
        {
          value: 7,
          label: "禁言7天",
        },
        {
          value: 14,
          label: "禁言14天",
        },
        {
          value: 30,
          label: "禁言30天",
        },
        {
          value: 90,
          label: "禁言90天",
        },
        {
          value: 180,
          label: "禁言180天",
        },
        {
          value: 365,
          label: "禁言365天",
        },
      ],
      datePickerValue: [],
    };
  },
  components: {
    breadCrumb,
    pagination,
  },
  async created() {
    this.getArticleList();
  },
  mounted() {},
  methods: {
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.getArticleList();
    },
    //获取文章列表
    getArticleList() {
      let params = {
        tenantId: parseInt(this.$route.query.tenantid),
        businessId: this.getBusinessId(parseInt(this.$route.query.tenantid)),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        penalizedPin: this.searchParams.penalizedPin,
        durationDays: this.searchParams.durationDays,
        createBy: this.searchParams.createBy,
        startTime: this.datePickerValue?.[0]
          ? utils.timetamp(this.datePickerValue?.[0])
          : "",
        endTime: this.datePickerValue?.[1]
          ? utils.timetamp(this.datePickerValue?.[1])
          : "",
      };
      queryUserPenalties(params).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          this.tableData.tableList.push(item);
        });
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
        console.log(
          "???",
          res.data,
          this.tableData,
          this.tableData.tableList[1]
        );
      });
    },

    handleReset() {
      this.searchParams = {
        penalizedPin: "",
        durationDays: "",
        createBy: "",
      };
      this.datePickerValue = [];
      this.paginationDataProduct.currentPage = 1;
      this.getArticleList();
    },
    handleSearch() {
      this.paginationDataProduct.currentPage = 1;
      this.getArticleList();
    },
    getBusinessId(key) {
      switch (key) {
        case 287:
          return 359;
        case 290:
          return 320;
        case 484:
          return 580;
        case 492:
          return 611;
        case 501:
          return 618;
        case 523:
          return 619;
        default:
          return 320;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content-audit-tabel {
  position: relative;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
  &.specil {
    :deep(.el-tabs) {
      padding-bottom: 0;
      margin-bottom: 0;
    }
    :deep(.el-tabs__content) {
      display: none;
    }
    :deep(.el-tabs__header) {
      margin-bottom: 0;
    }
  }
  .import-btn {
    position: absolute;
    right: 20px;
    top: 20px;
    z-index: 11;

    .redTag {
      color: red;
    }
  }
}

.slot-item {
  span {
    margin: 0px 2px 0px 2px;
  }
}

:deep(.el-textarea__inner) {
  min-height: 130px !important;
  resize: none;
}

:deep(.el-form-item) {
  margin-bottom: 22px;
}

:deep(.modal-body) {
  margin-top: 30px;
}

.reasonDom {
  padding: 0 30px;
  height: 100px;
  line-height: 20px;
  font-size: 14px;
  color: rgba(44, 52, 67, 1);
  /*overflow: hidden;*/
  overflow-y: auto;
  max-height: 150px;
}

.freezeDom {
  /*margin-top: 30px;*/
  .freezeInp {
    max-height: 130px;
    max-width: 276px;

    // overflow: hidden;
    .el-input__count {
      background: rgba(0, 0, 0, 0);
      bottom: -30px;
    }
  }

  .mar-top30 {
    margin-top: 30px;
  }
}

.importBtn {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  margin-left: 5px;
}

.exportBtn {
  margin-left: 5px;

  span {
    margin-top: 5px;
    display: block;
    color: #abaaaa;
  }
}

.dropDown {
  margin-left: 10px;
}

.header-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header {
  font-size: 20px;
  font-weight: bold;
}

.form-container {
  height: 80vh;
  /* 设置固定高度 */
  overflow-y: auto;
  /* 启用垂直滚动条 */
}

:deep(.el-form-item__label) {
  font-weight: bold;
  /* 加粗 */
  margin-right: 20px;
  /* 右边距 */
}

.image-flex {
  display: flex;
  flex-wrap: wrap;
  /* 自动换行 */
  gap: 10px;
  /* 图片间距 */
}

.image-item {
  position: relative;
  width: calc(33.33% - 10px);
  /* 每行3个，减去间距 */
  height: 100px;
  /* 设置图片容器高度 */
  overflow: hidden;
  margin-bottom: 10px;
  /* 图片之间的垂直间距 */
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 图片覆盖容器 */
  cursor: pointer;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
}

.image-item:hover .image-overlay {
  opacity: 1;
}

.image-overlay .el-button {
  margin: 0 5px;
}

.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.input-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}

.button-group {
  display: flex;
  gap: 10px;
}

.multiSelect {
  display: flex;
  align-items: center;
  // justify-content: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.select-blue {
  margin-right: 5px;
  // color: blue;
}

.select-white {
  margin-right: 5px;
  color: rgb(0, 0, 0);
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
  /* 确保背景色 */
}

.drawer-footer .el-button {
  margin-left: 10px;
}
.piliangBox {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
}
</style>
